import type { RouteRecordRaw } from 'vue-router';
import type { App } from 'vue';

import { createRouter, createWebHashHistory } from 'vue-router';
import { basicRoutes } from './routes';

// 白名单应该包含基本静态路由
const WHITE_NAME_LIST: string[] = [];
const getRouteNames = (array: any[]) =>
  array.forEach((item) => {
    WHITE_NAME_LIST.push(item.name);
    getRouteNames(item.children || []);
  });
getRouteNames(basicRoutes);

// app router
export const router = createRouter({
  history: createWebHashHistory(import.meta.env.VITE_PUBLIC_PATH),
  routes: basicRoutes as unknown as RouteRecordRaw[],
  strict: true,
  scrollBehavior: () => ({ left: 0, top: 0 }),
});

// 懒加载代码块丢失自动恢复(老板 2026-09-30):平台频繁部署后,部署前就打开的
// 旧标签页仍持旧资源清单,首次跳转到未访问过的页面会 404 拉取已删除的 chunk,
// 路由导航静默中止(用户看到"点了没反应")。此处捕获该类错误自动整页刷新一次,
// 让用户无感知地换到新版本;30 秒窗口防刷新死循环。
router.onError((error) => {
  const msg = String((error as Error)?.message || '');
  const isChunkLoadFailure =
    msg.includes('Failed to fetch dynamically imported module') ||
    msg.includes('Importing a module script failed') ||
    msg.includes('error loading dynamically imported module') ||
    /Loading chunk \d+ failed/.test(msg) ||
    msg.includes('dynamically imported module');
  if (!isChunkLoadFailure) return;
  const KEY = 'DR_CHUNK_RELOAD_AT';
  const last = Number(sessionStorage.getItem(KEY) || 0);
  if (Date.now() - last > 30_000) {
    sessionStorage.setItem(KEY, String(Date.now()));
    window.location.reload();
  }
});

// reset router
export function resetRouter() {
  router.getRoutes().forEach((route) => {
    const { name } = route;
    if (name && !WHITE_NAME_LIST.includes(name as string)) {
      router.hasRoute(name) && router.removeRoute(name);
    }
  });
}

// config router
export function setupRouter(app: App<Element>) {
  app.use(router);
}
